import { formatMonetary } from '@ferreri/prever-component-lib';
import { Publication } from '../modules/publications/publications.types';

export const formatPromotionValue = (publication: Publication) => {
  if (!publication?.prever_member_value) return '';

  const isAbsolute = publication?.promotion_kind === 'absolute';
  const value = publication?.prever_member_value;
  const text = 'de desconto';

  if (isAbsolute) return `${formatMonetary(value)} ${text}`;

  return `${value}% ${text}`;
};
